<template>
    <div>
        <div class="row">
            <div class="col-md-6 animated slideInLeft">
                <div class="card card-body h-100 justify-content-center shadow">
                    <h2 class="mt-3 mr-5 ml-5">About Book A Pickup</h2>
                    <div class="m-5">
                        <p class="mb-5">Book a Pickup allows you to do just that - book in a third party return, handle return logistics or process general freight collections.</p>
                        <p class="mb-5">To get started, key in the details to the right that you were provided in an email from your receiver.</p>
                        <p>If you want to find out more about and how to improve your logistics, have a chat with <a href='https://tigfreight.com.au' target="_blank" class="text-info">TIG Freight</a>.</p>
                    </div>
                    <div class="text-center">
                        <a href="https://bookapickup.com.au/" target="_blank"><img src="/static/images/logos/bap.png" class="w-25 mr-5" alt=""></a>
                        <a href="https://tigfreight.com/" target="_blank"><img src="/static/images/logos/tig.png" class="w-25 ml-5" alt=""></a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 animated slideInRight">
                <div class="card h-100 card-body justify-content-center shadow">
                    <div class="m-5">
                        <h2 class="text-center mb-5">Book A Pickup</h2>
                        <p class="text-center lead">Return Logistics, powered by <a class="text-info" href="https://openfreight.com.au/">OpenFreight</a></p>
                    </div>
                    <form class="m-5">
                        <div class="form-group">
                            <label for="returnCode"><span class="text-danger">*</span> Return Code</label>
                            <input v-model="consignmentId" type="text" class="form-control" id="returnCode" placeholder="Enter Your Return Code">
                        </div>
                        <div class="form-group ">
                            <label for="validationField"><span class="text-danger">*</span> Validation Field</label>
                            <input v-model="validateField" type="text" class="form-control" id="validationField" placeholder="Enter Your Validation Number">
                        </div>
                        <div class="text-center mt-5">
                            <button @click.prevent="tryGoToNextStep" :disabled="isLoading()" class="btn btn-primary w-50">Continue</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Messages -->
        <messages-output v-bind:messages="messages"></messages-output>
    </div>
</template>

<script>
    import Messages from '@/helpers/Messages'
    import MessagesOutput from '@/components/MessagesOutput'
    export default {
        name: 'Root',
        props: ['branding'],
        components: {
            MessagesOutput
        },
        data () {
            return {
                loading: false,
                messages: new Messages(), // Use for showing messages
                consignmentId: '', // This is binded to our inputs and passed with our request
                validateField: '', // Similar to above
                faqOneOpen: false,
                faqTwoOpen: false
            }
        },
        methods: {
            /**
             * Is this loading
             */
            isLoading: function () {
                return this.loading
            },
            /**
             * Set loading
             */
            setLoading: function (newVal) {
                this.loading = newVal
            },
            /**
             * Load config
             *
             * This queries the API to get the inital configuration
             *
             */
            createValidateReturnConsignmentPublicRequest: function () {
                this.setLoading(true)
                // On the page load we load the config
                this.$http.post('/', {
                    request: 'ValidateReturnConsignmentPublic',
                    consignment_id: this.consignmentId,
                    validate_field: this.validateField
                }).then(response => {
                    this.setLoading(false)

                    // Check if there's any errors
                    if (!this.messages.check200ResponseForErrors(response.data)) {
                        this.$router.push({ name: 'book', params: { consignmentReturnCode: response.data.return } })
                    }
                }).catch(e => {
                    this.setLoading(false)
                    this.messages.addErrorsFrom400Response(e)
                })
            },
            /**
             * Tries to submit the form and route the application based on it's result.
             *
             */
            tryGoToNextStep: function () {
                // Setup for new messages
                this.messages.clearMessages()
                let validationResult = true

                // 1. Validate Con ID (Consignment ID)
                if (!this.consignmentId.trim()) {
                    // Most likely it's empty or null...
                    this.messages.addMessage('Please enter a Consignment Number', 0)
                    // Don't let us go to the next step just yet..
                    validationResult = false
                }
                // 2. Validate validateField ("Validate" Field)
                if (!this.validateField.trim()) {
                    // Most likely it's empty or null...
                    this.messages.addMessage('Please enter a Validate Field', 0)
                    // Don't let us go to the next step just yet..
                    validationResult = false
                }

                // 3. If validation succeeded do some things...
                if (validationResult) {
                    // Let's make the request
                    this.createValidateReturnConsignmentPublicRequest()
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .slide-enter-active, .slide-leave-active {
        transition: all 0.3s;
    }
    .slide-enter {
        transform: translateX(100%);
    }
    .slide-leave-to {
        transform: translateX(-100%);
    }
</style>
